import React, { useState } from 'react';

interface GdprModalProps {
    isOpen: boolean;
    onClose: () => void;
    patientId: number;
}

export const GdprModal: React.FC<GdprModalProps> = ({ isOpen, onClose, patientId }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [statusMessage, setStatusMessage] = useState<string | null>(null);

    if (!isOpen) return null;

    const handleSendEmail = async () => {
        setIsLoading(true);
        setStatusMessage(null);
        try {
            const response = await fetch(`/api/gdpr/initiate/${patientId}`, {
                method: 'POST'
            });

            if (response.ok) {
                setStatusMessage("Το email επιβεβαίωσης στάλθηκε με επιτυχία!");
                setTimeout(onClose, 2000); // Κλείσιμο αυτόματα μετά από 2 δευτερόλεπτα
            } else {
                throw new Error("Αποτυχία αποστολής");
            }
        } catch (error) {
            setStatusMessage("Προέκυψε σφάλμα κατά την αποστολή.");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        // Overlay (Το γκρι φόντο)
        <div style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
            justifyContent: 'center', alignItems: 'center', zIndex: 1000
        }}>
            {/* Modal Box */}
            <div style={{
                backgroundColor: 'white', padding: '24px', borderRadius: '8px',
                width: '400px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
            }}>
                <h3 style={{ marginTop: 0 }}>GDPR Επιβεβαίωση</h3>
                <p>Θέλετε να στείλετε το έγγραφο συγκατάθεσης GDPR στον ασθενή;</p>
                
                {statusMessage && (
                    <div style={{ padding: '10px', marginBottom: '10px', borderRadius: '4px', 
                                  backgroundColor: statusMessage.includes("σφάλμα") ? '#fee' : '#efe' }}>
                        {statusMessage}
                    </div>
                )}

                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
                    <button onClick={onClose} disabled={isLoading} style={{ padding: '8px 16px', cursor: 'pointer' }}>
                        Ακύρωση
                    </button>
<button 
  onClick={handleSendEmail} 
  disabled={isLoading} 
  className="px-4 py-2 bg-primary hover:bg-darkprimary text-white border-none rounded cursor-pointer transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
>
  {isLoading ? 'Αποστολή...' : 'Αποστολή Email'}
</button>
                </div>
            </div>
        </div>
    );
};